import {
	useImportedAssetTypes,
	useReleasedAssetPickerOptions,
} from '../../hooks/assetSchemaHooks';
import {
	AssetSchema,
	AssetTypeSummary,
	PickerStatus,
	SystemType,
} from '@innovyze/lib_asset_schema';

// Rehab only offers asset types that support the 'Rehab' capability, so types
// it cannot model (for example the Water Distribution customer type) are not
// offered, and only types the tenant has imported.
const useRehabPickerOptions = (): ReturnType<
	typeof useReleasedAssetPickerOptions
> =>
	useReleasedAssetPickerOptions({
		imported: useImportedAssetTypes(),
		capability: 'Rehab',
	});

export function useEnabledSystemTypes(): {
	enabledSystemTypes: readonly SystemType[];
	pickerStatus: PickerStatus;
} {
	const { systemTypes, status } = useRehabPickerOptions();

	return { enabledSystemTypes: systemTypes, pickerStatus: status };
}

export function useEnabledAssetTypes(systemType?: SystemType): {
	enabledAssetTypes: readonly AssetTypeSummary[];
} {
	const { assetTypesFor } = useRehabPickerOptions();

	if (!systemType) {
		return { enabledAssetTypes: [] };
	}

	return { enabledAssetTypes: assetTypesFor(systemType.id) };
}

export function useEnabledInspectionStandards(assetType?: AssetSchema): {
	enabledInspectionStandards: readonly string[];
} {
	const enabledInspectionStandards = assetType?.getInspectionTypes() ?? [];

	return { enabledInspectionStandards };
}
